class HelpTOCManager {
  constructor(container) {
    this.container = container;
    this.activeKey = false;
    this.helpLinks = [];
    this.setup = false;
  }

  setActiveKey(key) {
    this.activeKey = key;
  }

  activateContentTitle(key) {
    this.container.find(".active").removeClass("active");
    this.container.find(".active-parent").removeClass("active-parent");
    if (key) {
      var activeElement = this.container.find('[data-help-link="' + key + '"]');
    } else {
      return;
    }
    activeElement.parent(".help-table-contents-item").addClass("active");
    activeElement.parents(".help-table-contents-item").addClass("active-parent");
    this.setActiveKey(key);
  }

  addHelpLink(key) {
    this.helpLinks.push(key);
  }

  getHelpContents() {
    if (this.setup) {
      return new jQuery.Deferred().resolve().promise();
    } else {
      this.setup = true;

      return jQuery.get({ url: "/admin/help_entries.json", data: { titles: this.helpLinks } }, (data) => {
        this._createTableOfContents(data);
      });
    }
  }

  // PRIVATE

  _createTableOfContents(data) {
    this.container.append(
      '<div class="help-table-title"><h2 class="help-table-title-header">Contents</h2><div class="help-table-hide-toc"></div></div>',
    );
    const $listHolder = jQuery('<ul class="help-table-contents"></ul>');
    let $element;
    let $footer;

    data.forEach((item) => {
      if (item.key == "Footer") {
        $footer = this.renderFooter(item.children[0]);
      } else {
        $element = this.renderListItem(item);
        this._createChildren(item, $element);
        $listHolder.append($element);
      }
    });

    this.container.append($listHolder);
    this.container.append($footer);
  }

  _createChildren(item, parentElement) {
    if (item.children && item.children.length) {
      const childrenList = jQuery('<ul class="children"></ul>');
      let element;
      parentElement.append(childrenList);
      parentElement.append(childrenList).addClass("--has-children");

      item.children.forEach((child) => {
        element = this.renderListItem(child, true);
        childrenList.append(element);
        this._createChildren(child, element);
      });
    }
  }

  renderFooter(item) {
    const $footer = jQuery(
      '<footer class="help-table-contents-footer" ><span class="help-table-contents-title" data-help-link="' +
        item.key +
        '">' +
        item.title +
        "</span></footer>",
    );
    const $icon = createIconTag("support-color");
    $footer.prepend($icon);
    return $footer;
  }

  renderListItem(item) {
    const dataAttributes = {
      "data-help-link": item.key,
    };
    const iconVariations = ["color", "filled"];
    const hasChildren = !!item.children.length;

    if (item.type) {
      dataAttributes["data-help-type"] = item.type;
    }

    const $icon = createIconTag(`help-${item.icon}`, {
      variations: iconVariations,
      wrapperClass: "help-table-contents-title__leading-icon",
    });
    const $title = jQuery(
      `<span class="help-table-contents-title"><span class="help-table-contents-title__text">${item.title}</span></span>`,
    )
      .attr(dataAttributes)
      .prepend($icon);

    if (hasChildren) {
      $title.append(
        createIconTag(`chevron-down`, {
          variations: iconVariations,
          class: "help-table-contents-title__trailing-icon",
        }),
      );
    }
    return jQuery('<li class="help-table-contents-item">').append($title);
  }
}

window.HelpTOCManager = HelpTOCManager;
